import React from 'react'
import { connect } from 'dva'
import { modelUtils } from '../../../../utils'
import { component_tool, framework_tool, utils_tool } from '@/tool';
import { ChartsInfo } from '../../../../components'
import { getDetailRecord } from '@/containers/content/util'
import createColumns from './columns'
import moment from 'moment';

let { WizContainer } = framework_tool
let { Session, getPageData, excelUtils } = utils_tool
let { WizSpin, WizCard, WizTabs, WizSearchBar, WizButton, WizDataTable, WizBrowserExport, WizRow, WizCol, WizTypography } = component_tool
const { Title, Text, Paragraph } = WizTypography

class PracticeRecord extends WizContainer {
  componentName = 'PracticeRecord';

  constructor(props) {
    super(props);
    this.detailInfo = getDetailRecord(props.history);
    this.state = {
      practiceId: this.detailInfo.id,
      record: this.detailInfo
    };
    this.rankFilters = {}
    this.rankAllFilters = {}
  }

  _componentDidMount = () => {
    let { practiceId } = this.state
    this._getChartData(practiceId)
    this._getDateChartData(practiceId)
    this._getRecordPageList()
  }

  /**获取图表数据*/
  _getChartData(practiceId) {
    let apiPath = "practiceRank/chartsInfo";
    this.doAction({
      path: apiPath,
      payload: {
        key: 'practiceChartsInfo',
        apiParams: { practiceId: practiceId }
      }
    })
  }
  _getDateChartData(practiceId) {
    let apiPath = "practiceRank/dateChartsInfo";
    this.doAction({
      path: apiPath,
      payload: {
        key: 'dateChartsInfo',
        apiParams: { practiceId: practiceId }
      }
    })
  }

  propsAndStateOnChange = {
    infoCharts: this._infoChartsOver.bind(this),
    dateInfoCharts: this._dateInfoChartsOver.bind(this),
    recordPageList: this._recordPageListOver.bind(this),
    recordList: this._recordListOver.bind(this),
    detailPageList: this._detailPageListOver.bind(this),
    detailList: this._detailListOver.bind(this),
  }

  /**图表数据获取情况*/
  _infoChartsOver(nextProps, nextState) {
    let data = []
    if (nextProps.infoCharts.code === 1) {
      data = nextProps.infoCharts.data
      this.chartsData = data
      return true;
    } else {
      wizNotice.error('图表数据获取失败！！')
      return false;
    }
  }
  _dateInfoChartsOver(nextProps, nextState) {
    let data = []
    if (nextProps.dateInfoCharts.code === 1) {
      data = nextProps.dateInfoCharts.data
      this.dateChartsData = data
      return true;
    } else {
      wizNotice.error('当日图表数据获取失败！！')
      return false;
    }
  }

  _recordPageListOver(nextProps, nextState) {
    let { recordPageList } = nextProps
    if (recordPageList['success']) {
      return true;
    } else {
      wizNotice.error(recordPageList['msg'] || '获取数据失败，请稍后再试')
    }
    return false
  }

  _detailPageListOver(nextProps, nextState) {
    let { detailPageList } = nextProps
    if (detailPageList['success']) {
      return true;
    } else {
      wizNotice.error(detailPageList['msg'] || '获取数据失败，请稍后再试')
    }
    return false
  }

  _recordListOver(nextProps, nextState) {
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'left',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '姓名',
        field: 'fullName',
        width: 20,
      },
      {
        headerName: '账号',
        field: 'userName',
        width: 20,
      },
      {
        headerName: '账号状态',
        field: 'accountState',
        width: 20,
      },
      {
        headerName: '任职信息',
        field: 'userIdentityInfoListStr',
        width: 35,
      },
      {
        headerName: '练习天数',
        field: 'days',
        width: 20,
      },
      {
        headerName: '练习次数',
        field: 'count',
        width: 20,
      },
      {
        headerName: '平均正确率',
        field: 'avgAccuracy',
        width: 20,
      },
      {
        headerName: '最优正确率',
        field: 'maxAccuracy',
        width: 20,
      },
      {
        headerName: '平均练习时长(秒)',
        field: 'avgDuration',
        width: 20,
      }
    ]
    if (nextProps.recordList.code === 1) {
      let data = nextProps.recordList.data
      data && data.length && data.forEach(d => {
        if (d.userIdentityInfoList && d.userIdentityInfoList.length) {
          let userIdentityInfoListStr = '';
          d.userIdentityInfoList.forEach(_d => {
            if (userIdentityInfoListStr === '') {
              userIdentityInfoListStr = _d.positionName + ' - ' + _d.orgName;
            } else {
              userIdentityInfoListStr = userIdentityInfoListStr + '、' + _d.positionName + ' - ' + _d.orgName;
            }
          })
          d['userIdentityInfoListStr'] = userIdentityInfoListStr;
        }
        if (d.accountState != null) {
          d['accountState'] = d.accountState === 1 ? '激活' : '禁用';
        }
        d.avgAccuracy = d.avgAccuracy + '%'
        d.maxAccuracy = d.maxAccuracy + '%'
      })
      WizBrowserExport({
        title: '练习记录汇总',
        sheetName: '练习记录汇总',
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: '练习记录汇总.xlsx',
      })
      return true;
    } else {
      wizNotice.error('获取导出数据失败')
      return false;
    }
  }

  _detailListOver(nextProps, nextState) {
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)'
        }
      },
      {
        headerName: '姓名',
        field: 'fullName',
        width: 20
      },
      {
        headerName: '账号',
        field: 'userName',
        width: 20
      },
      {
        headerName: '账号状态',
        field: 'accountState',
        width: 20,
      },
      {
        headerName: '任职信息',
        field: 'userIdentityInfoListStr',
        width: 35
      },
      {
        headerName: '练习开始时间',
        field: 'startDate',
        width: 20,
      },
      {
        headerName: '练习结束时间',
        field: 'endDate',
        width: 20,
      },
      {
        headerName: '答题时长(秒)',
        field: 'duration',
        width: 20,
      },
      {
        headerName: '答对题数',
        field: 'correctNum',
        width: 20,
      },
      {
        headerName: '习题数量',
        field: 'questionNum',
        width: 20,
      },
      {
        headerName: '正确率',
        field: 'accuracy',
        width: 20,
      },
    ]
    if (nextProps.detailList.code === 1) {
      let data = nextProps.detailList.data
      data && data.length && data.forEach(d => {
        if (d.userIdentityInfoList && d.userIdentityInfoList.length) {
          let userIdentityInfoListStr = '';
          d.userIdentityInfoList.forEach(_d => {
            if (userIdentityInfoListStr === '') {
              userIdentityInfoListStr = _d.positionName + ' - ' + _d.orgName;
            } else {
              userIdentityInfoListStr = userIdentityInfoListStr + '、' + _d.positionName + ' - ' + _d.orgName;
            }
          })
          d['userIdentityInfoListStr'] = userIdentityInfoListStr;
        }
        if (d.accountState != null) {
          d['accountState'] = d.accountState === 1 ? '激活' : '禁用';
        }
        d.accuracy = d.accuracy + '%'
      })
      WizBrowserExport({
        title: '练习记录详情',
        sheetName: '练习记录详情',
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: '练习记录详情.xlsx',
      })
      return true;
    } else {
      wizNotice.error('获取导出数据失败')
      return false;
    }
  }

  changeTab = (e) => {
    if (e === '1') {
      this._getRecordPageList()
    } else if (e === '2') {
      this._getDetailPageList()
    }
  }

  _getRecordPageList(apiParams = {}) {
    let { practiceId } = this.state
    this.doAction({
      path: 'practiceRecord/list',
      payload: {
        key: 'recordPageList',
        apiParams: {
          practiceId: practiceId,
          ...apiParams
        }
      }
    })
  }

  _getDetailPageList(apiParams = {}) {
    let { practiceId } = this.state
    this.doAction({
      path: 'practiceRecord/detailList',
      payload: {
        key: 'detailPageList',
        apiParams: {
          practiceId: practiceId,
          ...apiParams
        }
      }
    })
  }

  _getRecordList(apiParams = {}) {
    let { practiceId } = this.state
    this.doAction({
      path: 'practiceRecord/export',
      payload: {
        key: 'recordList',
        apiParams: {
          practiceId: practiceId,
          ...apiParams
        }
      }
    })
  }

  _getDetailList(apiParams = {}) {
    let { practiceId } = this.state
    this.doAction({
      path: 'practiceRecord/detailExport',
      payload: {
        key: 'detailList',
        apiParams: {
          practiceId: practiceId,
          ...apiParams
        }
      }
    })
  }

  _onSelect(keys, rows) {
    this.setState({
      keys,
      rows,
      selectedRows: keys.length
    })
  }

  _renderBtn = (type) => {
    let r = []
    let btns = new Map();
    btns.set('export',
      <WizButton title="导出"
        type="export"
        onClick={() => {
          if (type === 'record') {
            this._getRecordList(this.rankFilters)
          }
          if (type === 'detail') {
            this._getDetailList(this.rankAllFilters)
          }
        }}
        icon="export"
        style={{ marginBottom: 15 }}>导出</WizButton>
    );
    let btnCode = this.getMenuBtn() || [];
    btnCode.map(({ code }) => {
      if (btns.has(code)) {
        r.push(btns.get(code))
      }
    })
    return r
  }

  renderRecordInfo = (type) => {
    let { recordPageList, detailPageList, practiceRecordLoading } = this.props
    let columns = createColumns(this, type)
    let pageList = type === 'record' ? recordPageList : detailPageList
    let list = getPageData(pageList && pageList.data)
    let searchBarProps = {
      columns,
      onSearch: values => {
        let params = Object.assign({}, values)
        if (params.practiceDate && params.practiceDate.length === 2) {
          params.startDate = moment(params.practiceDate[0]).format('YYYY-MM-DD HH:mm:00')
          params.endDate = moment(params.practiceDate[1]).format('YYYY-MM-DD HH:mm:59')
        } else {
          params.startDate = null
          params.endDate = null
        }
        params.practiceDate = null
        if (type === 'record') {
          this.rankFilters = params
          this._getRecordPageList(params)
        }
        if (type === 'detail') {
          this.rankAllFilters = params
          this._getDetailPageList(params)
        }
      }
    }
    let dataTableProps = {
      loading: practiceRecordLoading,
      columns,
      rowKey: 'id',
      dataItems: list,
      isScroll: true,
      onChange: ({ pageNum, pageSize }) => {
        if (type === 'record') {
          this._getRecordPageList({ current: pageNum, size: pageSize, ...this.rankFilters })
        }
        if (type === 'detail') {
          this._getDetailPageList({ current: pageNum, size: pageSize, ...this.rankAllFilters })
        }
      },
      onSelect: (keys, rows) => this._onSelect(keys, rows)
    }
    return (
      <WizSpin tip={'加载中'} spinning={practiceRecordLoading}>
        <div className='pagination'>
          <WizSearchBar key="practiceRecord_searchBar" type="grid" {...searchBarProps} />
        </div>
        {this._renderBtn(type)}
        <WizDataTable key={'practiceRecord_dataTable'} {...dataTableProps} />
        <div className='pagination'>
          <WizDataTable.Pagination key={'practiceRecord_pagination'} {...dataTableProps} />
        </div>
      </WizSpin>
    )
  }


  _onLook = (record) => {
    this.jumpPage('push', '/online/practice/record/paper', record)
  }

  _renderContentRow(ln, lv = '', rn, rv = '') {
    return (
      <WizRow className='administrationScope-row-item'>
        <WizCol className='col-item' span={3} offset={1}><Text strong>{ln + '：'}</Text></WizCol>
        <WizCol span={6}><Text strong>{lv}</Text></WizCol>
        <WizCol className='col-item' span={3} offset={2}><Text strong>{rn + '：'}</Text></WizCol>
        <WizCol span={9}><Text strong>{rv}</Text></WizCol>
      </WizRow>
    )
  }
  _chartsHead = (record) => {
    let chartsHead = []
    if (record?.id) {
      chartsHead = ['练习名称', record.name, '练习时间', record.startDate + ' ~ ' + record.endDate]
    }
    return this._renderContentRow(chartsHead[0], chartsHead[1], chartsHead[2], chartsHead[3])
  }

  _render() {
    let londing = this.props.practiceRankLoading || this.props.practiceRankLoading
    let { record } = this.state

    let chartsHead = []
    if (record?.id) {
      chartsHead = ['练习名称', record.name, '练习时间', record.startDate + ' ~ ' + record.endDate]
    }
    let practicePrecent = this.chartsData ? <ChartsInfo
      percentProps={{
        key : 'practicePrecent',
        data: [
          {
            item: "已参与人数",
            count: this.chartsData.practiceNumCount,
          },
          {
            item: "未参与人数",
            count: this.chartsData.practiceNotNumCount,
          }
        ],
        dataFormat: {
          type: "percent",
          field: "count",
          dimension: "item",
          as: "percent"
        },
        count: this.chartsData.practiceNum,
        centerText: '总练习概况',
        colors:['rgb(0,157,255)','#22E4FFFF']
      }}
    /> : null

    let datePracticePrecent = this.dateChartsData ? <ChartsInfo
      percentProps={{
        key : 'datePracticePrecent',
        data: [
          {
            item: "已参与人数",
            count: this.dateChartsData.practiceNumCount,
          },
          {
            item: "未参与人数",
            count: this.dateChartsData.practiceNotNumCount,
          }
        ],
        dataFormat: {
          type: "percent",
          field: "count",
          dimension: "item",
          as: "percent"
        },
        count: this.dateChartsData.practiceNum,
        centerText: '日练习概况',
        colors:['rgb(71,145,213)','rgb(34,233,144)']
      }}
    /> : null
    return (
      <>
        <WizSpin tip={"加载中"} spinning={londing}>
          <WizCard title={'练习概况'}>
              {this._chartsHead(record)}
              <WizRow>
                <WizCol span={12}>{practicePrecent}</WizCol>
                <WizCol>{datePracticePrecent}</WizCol>
              </WizRow>
            </WizCard>
          <WizCard>
            <WizTabs defaultActiveKey="1" onChange={this.changeTab}>
              <WizTabs.TabPane tab={'记录汇总'} key="1">
                {this.renderRecordInfo('record')}
              </WizTabs.TabPane>
              <WizTabs.TabPane tab={'记录详情'} key="2">
                {this.renderRecordInfo('detail')}
              </WizTabs.TabPane>
            </WizTabs>
          </WizCard>
        </WizSpin>
      </>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { practiceRecord, practiceRank } = state;
  const infoCharts = modelUtils.getModelEntity(practiceRank, 'practiceChartsInfo')
  const dateInfoCharts = modelUtils.getModelEntity(practiceRank, 'dateChartsInfo')
  const recordPageList = modelUtils.getModelEntity(practiceRecord, 'recordPageList')
  const recordList = modelUtils.getModelEntity(practiceRecord, 'recordList')
  const detailPageList = modelUtils.getModelEntity(practiceRecord, 'detailPageList')
  const detailList = modelUtils.getModelEntity(practiceRecord, 'detailList')
  const load = modelUtils.getLoadingState(state, ['practiceRecord','practiceRank']);
  return {
    infoCharts,
    dateInfoCharts,
    recordPageList,
    recordList,
    detailPageList,
    detailList,
    ...load
  }

};

export default connect(mapStateToProps)(PracticeRecord);
